/** Na Home (durante) e no Mapa: o carro marcado, ou o botão "Estacionei aqui". */
import { featureEnabled } from '@nv/core';
import { useState } from 'react';

import { useTrip } from '../../trip/TripContext';
import { Row } from '../../ui/primitives';
import { useCarro, useInvalidarCarro } from './api';
import { CarroCard } from './CarroCard';
import { EstacioneiAqui } from './EstacioneiAqui';

export function CarroNaHome() {
  const { trip, tripId } = useTrip();
  const ligado = featureEnabled(trip.features, 'carro');
  const carro = useCarro(tripId, ligado);
  useInvalidarCarro(tripId);
  if (!ligado) return null;
  return (
    <>
      {carro.data?.car && <CarroCard carro={carro.data.car} />}
    </>
  );
}

/** A linha "Estacionei aqui" para a lista de Atalhos — some quando o carro já está marcado. */
export function EstacioneiNosAtalhos() {
  const { trip, tripId } = useTrip();
  const ligado = featureEnabled(trip.features, 'carro');
  const carro = useCarro(tripId, ligado);
  const [marcando, setMarcando] = useState(false);
  if (!ligado || carro.data?.car) return null;
  return (
    <>
      <Row icon="carro" title="Estacionei aqui" onClick={() => setMarcando(true)} data-testid="estacionei" />
      {marcando && <EstacioneiAqui onFechar={() => setMarcando(false)} />}
    </>
  );
}
